'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineConnectorProps } from '@mui/lab/TimelineConnector';

import MuiTimelineConnector from '@mui/lab/TimelineConnector';

export type { TimelineConnectorProps };

export const TimelineConnector: React.FC<TimelineConnectorProps> =
  MuiTimelineConnector;

TimelineConnector.displayName = 'TimelineConnector';
